// Static imports only (Metro/webpack are bundler-static). Add a line here when
// a new <slug>.<lang>.json overlay file is created. English is the source in
// the content modules, so there is no "en" entry.
import cd_ar from "./conductive-dough-mission.ar.json";
import cd_de from "./conductive-dough-mission.de.json";
import cd_es from "./conductive-dough-mission.es.json";
import cd_fr from "./conductive-dough-mission.fr.json";
import cd_gu from "./conductive-dough-mission.gu.json";
import cd_hi from "./conductive-dough-mission.hi.json";
import cd_it from "./conductive-dough-mission.it.json";
import cd_ja from "./conductive-dough-mission.ja.json";
import cd_ko from "./conductive-dough-mission.ko.json";
import cd_mr from "./conductive-dough-mission.mr.json";
import cd_pt from "./conductive-dough-mission.pt.json";
import cd_ru from "./conductive-dough-mission.ru.json";
import cd_te from "./conductive-dough-mission.te.json";
import cd_zh from "./conductive-dough-mission.zh.json";

const JOURNEY_OVERLAYS = {
  "conductive-dough-mission": {
    ar: cd_ar,
    de: cd_de,
    es: cd_es,
    fr: cd_fr,
    gu: cd_gu,
    hi: cd_hi,
    it: cd_it,
    ja: cd_ja,
    ko: cd_ko,
    mr: cd_mr,
    pt: cd_pt,
    ru: cd_ru,
    te: cd_te,
    zh: cd_zh,
  },
};

export default JOURNEY_OVERLAYS;
